import { render, staticRenderFns } from "./WidgetProjectOverview.vue?vue&type=template&id=092ef1b3&scoped=true"
import script from "./WidgetProjectOverview.vue?vue&type=script&lang=js"
export * from "./WidgetProjectOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092ef1b3",
  null
  
)

export default component.exports